export enum DirectionType {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal"
}
